import { render, staticRenderFns } from "./TogglePublicViewBtn.vue?vue&type=template&id=67781d9c&scoped=true&"
import script from "./TogglePublicViewBtn.vue?vue&type=script&lang=js&"
export * from "./TogglePublicViewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67781d9c",
  null
  
)

export default component.exports